import React from "react";

const LocationMap = () => {
  return (
    <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1423.7963403301867!2d92.30603396194883!3d21.650300628294566!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30ad85843c313d91%3A0xb2285181b77511e2!2sThe%20Damtua%20Inn%20(Hotel%20%26%20Restaurant)!5e1!3m2!1sen!2sbd!4v1756478882205!5m2!1sen!2sbd"
        width="600"
        height="450"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="The Damtua Inn Location"
      ></iframe>
    </div>
  );
};

export default LocationMap;
